import { RouteConfig } from 'vue-router';
const ZhanghuList = () => import('./views/zhanghu/list.vue');
const ZhanghuEdit = () => import('./views/zhanghu/edit.vue');
const JueseList = () => import('./views/juese/list.vue');
const ZuzhiList = () => import('./views/zuzhi/list.vue');
const routers: RouteConfig[] = [
    {
        path: 'zhanghu-list',
        name: 'zhanghu-list',
        component: ZhanghuList
    },
    {
        path: 'zhanghu-edit',
        name: 'zhanghu-edit',
        component: ZhanghuEdit
    },
    {
        path: 'juese-list',
        name: 'juese-list',
        component: JueseList
    },
    {
        path: 'zuzhi-list',
        name: 'zuzhi-list',
        component: ZuzhiList
    },
    {
        path: '*',
        redirect: 'zhanghu-list'
    },
];
export default routers;

